import CheckList from "./CheckList";

export default CheckList;
export type { CheckListProps } from "./CheckList.d";
